export const mobileBannerOptions = [
  { label: "Product", value: "Product" },
  { label: "Category", value: "Category" },
  { label: "Store", value: "Store" },
  { label: "Market", value: "Market" },
  { label: "Video", value: "Video" },
  { label: "Page", value: "Page" },
  { label: "Campaign", value: "Campaign" },
];
